// extracted by mini-css-extract-plugin
export default {"page":"_2x1u59KYps9rkkDSDpkpvf","menu":"_2md8WXrR6v3nDvLId5fcMB","content":"_27aA_pd7cLyjICPon4aTQ_","itemContainer":"_15xBS7djeBtV6Bm9a5AfzJ"};